import React, { useEffect, useState } from "react";
import {
  BackgroundContainer,
  TitleContainer,
  ColorWrapper,
} from "./BackgroundStyles.styled.js";
import { SketchPicker } from "react-color";
import { setStateSurveyConfiguration } from "../../helpers/StateSurveyConfiguration";
import UploadImage from "../UploadImage/UploadImage";
import PubSub from "pubsub-js";

const BackgroundStyles = ({ styleBackgroundAll }) => {
  const [idSurvey, setIdSurvey] = useState(0);

  const [styleBackground, setStyleBackground] = useState({
    image: {},
    nameImage: "",
    color: {
      r: "241",
      g: "112",
      b: "19",
      a: "1",
    },
  });

  useEffect(() => {
    PubSub.subscribe("surveyId", (e, data) => {
      if (idSurvey !== data) {
        setIdSurvey(data);
      }
    });
  }, []);

  useEffect(() => {
    if (styleBackgroundAll) {
      setStyleBackground(styleBackgroundAll);
    }
  }, [styleBackgroundAll]);

  let handleStyleBackground = (type, item, urlPreviewImage) => {
    let updateStyleBackground = Object.assign({}, styleBackground);
    switch (type) {
      case "color":
        updateStyleBackground.color = `rgba(${item.r},${item.g},${item.b},${item.a})`;
        break;
      case "imagenFile":
        updateStyleBackground.image = item;
        updateStyleBackground.nameImage = item ? item[0].name : "";
        if (urlPreviewImage) {
          PubSub.publish("urlPreviewImageBackground", urlPreviewImage);
        }
        break;
      default:
        break;
    }

    setStateSurveyConfiguration(updateStyleBackground, "Background");
  };

  return (
    <div>
      <BackgroundContainer>
        <UploadImage
          displayNameButton="+ Image"
          setFile={handleStyleBackground}
          nameFile={styleBackground.nameImage}
        ></UploadImage>
      </BackgroundContainer>

      <BackgroundContainer>
        <TitleContainer>Color</TitleContainer>
        <ColorWrapper>
          <SketchPicker
            color={styleBackground.color}
            className="sketch-color"
            onChangeComplete={(colorPickerBackground) => {
              handleStyleBackground("color", colorPickerBackground.rgb);
            }}
          />
        </ColorWrapper>
      </BackgroundContainer>
    </div>
  );
};

export default BackgroundStyles;
